import { createSlice } from "@reduxjs/toolkit";

// Objetivos asignados a un participante, con su valor inicial y su
// criterio de logro para el seguimiento.
const initialState = {
    defaultEntity: {
        id: 0,
        idParticipante: 0,
        idObjetivoCatalogo: null,
        idTemaEvaluacion: 0,
        nombre: "",
        descripcion: "",
        fechaInicio: new Date().toISOString().substring(0, 10),
        valorInicial: "",
        criterioLogro: "",
        idEstado: 2,
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    entity: {
        id: 0,
        idParticipante: 0,
        idObjetivoCatalogo: null,
        idTemaEvaluacion: 0,
        nombre: "",
        descripcion: "",
        fechaInicio: new Date().toISOString().substring(0, 10),
        valorInicial: "",
        criterioLogro: "",
        idEstado: 2,
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    listParticipantes: [{ id: 0, descripcion: "" }],
    // Los objetivos del catalogo: al elegir uno se copian su nombre y su
    // descripcion al objetivo del participante.
    listObjetivos: [{ id: 0, descripcion: "" }],
    listTemas: [{ id: 0, descripcion: "" }],
    listEstados: [{ id: 0, descripcion: "" }],
    validationActive: {
        idParticipante: false,
        idTemaEvaluacion: false,
        nombre: false,
        fechaInicio: false,
        valorInicial: false,
        criterioLogro: false,
    },
    validationMessage: [],
}

export const participanteObjetivoSlice = createSlice({
    name: "participanteObjetivo",
    initialState,
    reducers: {
        setEntity: (state, action) => {
            state.entity = action.payload;
        },
        setData: (state, action) => {
            var { name, value } = action.payload;

            // Un id puede venir vacio a proposito (objetivo sin catalogo):
            // en ese caso se guarda null, no NaN.
            if (name.startsWith("id") && value != null) value = parseInt(value)

            state.entity[name] = value
            state.validationActive[name] = true
        },
        setListParticipantes: (state, action) => {
            state.listParticipantes = action.payload;
        },
        setListObjetivos: (state, action) => {
            state.listObjetivos = action.payload;
        },
        setListTemas: (state, action) => {
            state.listTemas = action.payload;
        },
        setListEstados: (state, action) => {
            state.listEstados = action.payload;
        },
        setValidationMessage: (state, action) => {
            state.validationMessage = action.payload;
        },
        activeValidations: (state, action) => {
            Object.keys(state.validationActive).forEach(function (key) {
                state.validationActive[key] = true;
            })
        },
    },
});

export const { setEntity, setData, setListParticipantes, setListObjetivos
    , setListTemas, setListEstados, setValidationMessage, activeValidations } = participanteObjetivoSlice.actions;
export default participanteObjetivoSlice.reducer;
